/* BR4NDOM New Era · un écran par pièce, la pièce qui flotte, le sac en direct (panier Shopify).
   Données : #deck-data (pièces, en JSON, préparées par snippets/deck.liquid), textes : #br-strings,
   réglages : window.BR (layout/theme.liquid). */
(() => {
  "use strict";
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const readJSON = id => { const el = document.getElementById(id); if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } };
  /* les textes traduits arrivent déjà encodés pour le HTML (ex. d&#39;abord) : on les remet en texte simple */
  const decoder = document.createElement("textarea");
  const plain = s => { decoder.innerHTML = s; return decoder.value; };
  const S = Object.fromEntries(Object.entries(readJSON("br-strings") || {}).map(([k, v]) => [k, typeof v === "string" ? plain(v) : v]));
  const t = (k, vars) => { let s = S[k] != null ? S[k] : k; if (vars) Object.keys(vars).forEach(v => { s = s.split("[" + v + "]").join(vars[v]); }); return s; };
  const BR = window.BR || {};
  const lang = (document.documentElement.lang || "en").slice(0, 2);
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const esc = s => String(s == null ? "" : s).replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  /* montants en centimes ; à la suisse en FR et DE : CHF 39.– */
  const amount = cents => { const n = Math.round(Number(cents) || 0) / 100; return Number.isInteger(n) ? (lang === "en" ? String(n) : n + ".–") : n.toFixed(2); };
  const money = cents => "CHF " + amount(cents);
  const isBack = a => { const n = ((a % 360) + 360) % 360; return n > 90 && n < 270; };
  let root = (window.Shopify && Shopify.routes && Shopify.routes.root) || BR.root || "/";
  if (root.slice(-1) !== "/") root += "/";
  const store = (kind, key, val) => { try { const s = window[kind]; if (val === undefined) return s.getItem(key); if (val === null) s.removeItem(key); else s.setItem(key, val); } catch (e) { return null; } };

  const toastEl = $("#toast");
  let toastT = 0;
  const toast = msg => {
    if (!toastEl) return;
    toastEl.textContent = msg; toastEl.classList.add("on");
    clearTimeout(toastT); toastT = setTimeout(() => toastEl.classList.remove("on"), 2400);
  };

  /* ---------- panneaux, menu ---------- */
  const scrim = $("#scrim");
  function closeAll() {
    $$(".sheet.on").forEach(x => { x.classList.remove("on"); x.setAttribute("aria-hidden", "true"); });
    if (scrim) scrim.classList.remove("on");
    const m = $("#menu"); if (m) { m.classList.remove("on"); m.setAttribute("aria-hidden", "true"); }
  }
  function openSheet(id) {
    closeAll();
    const el = document.getElementById(id); if (!el) return;
    el.classList.add("on"); el.setAttribute("aria-hidden", "false");
    if (scrim) scrim.classList.add("on");
    setTimeout(() => el.focus(), 60);
  }
  function openMenu() {
    closeAll();
    const m = $("#menu"); if (!m) return;
    m.classList.add("on"); m.setAttribute("aria-hidden", "false");
    setTimeout(() => m.focus(), 60);
  }
  document.addEventListener("click", e => {
    const o = e.target.closest("[data-open]");
    if (o) {
      const what = o.getAttribute("data-open");
      if (what === "menu") { e.preventDefault(); openMenu(); }
      else if (what === "bag") { e.preventDefault(); refreshCart().then(() => openSheet("bag")); }
      return;
    }
    if (e.target.closest("[data-close]")) closeAll();
  });
  if (scrim) scrim.addEventListener("click", closeAll);
  document.addEventListener("keydown", e => { if (e.key === "Escape") closeAll(); });

  /* ---------- sac (panier Shopify) ---------- */
  const bagCountEls = () => $$("[data-cart-count]");
  function paintCount(n, bump) {
    bagCountEls().forEach(el => {
      el.textContent = n;
      if (bump) { el.classList.remove("bump"); void el.offsetWidth; el.classList.add("bump"); }
    });
  }
  function sized(u, w) {
    if (!u) return "";
    if (typeof u === "object") u = u.src || u.url || "";
    return u + (u.indexOf("?") > -1 ? "&" : "?") + "width=" + w;
  }
  function renderBag(cart) {
    const list = $("#bag-list"), sum = $("#bag-sum");
    if (!list) return;
    if (!cart || !cart.item_count) {
      list.innerHTML = '<p class="empty">' + esc(t("bagEmpty")) + "</p>";
      if (sum) sum.hidden = true;
      return;
    }
    list.innerHTML = cart.items.map(it => {
      const variant = it.variant_title && !/default title/i.test(it.variant_title) ? esc(it.variant_title) + " · " : "";
      return `<div class="item" data-key="${esc(it.key)}">
        <a href="${esc(it.url)}">${it.image ? `<img src="${esc(sized(it.image, 160))}" alt="" width="64" height="58" loading="lazy">` : ""}</a>
        <div><p>${esc(it.product_title)}</p><small>${variant}${money(it.final_price)}</small>
          <div class="item__q"><button type="button" data-q="-1" aria-label="${esc(t("bagLess"))}">−</button><span>${it.quantity}</span><button type="button" data-q="1" aria-label="${esc(t("bagMore"))}">+</button></div></div>
        <div class="item__r"><span class="item__p">${money(it.final_line_price)}</span><button type="button" data-q="0">${esc(t("bagRemove"))}</button></div>
      </div>`;
    }).join("");
    $$(".item", list).forEach(row => {
      const it = cart.items.find(x => x.key === row.getAttribute("data-key"));
      $$("[data-q]", row).forEach(b => b.addEventListener("click", () => {
        const d = Number(b.getAttribute("data-q"));
        changeLine(it.key, d === 0 ? 0 : Math.max(0, it.quantity + d));
      }));
    });
    if (sum) {
      sum.hidden = false;
      $("#bag-total").textContent = money(cart.total_price);
      const free = Number(BR.free) || 4000, left = free - cart.total_price;
      $("#bag-free").textContent = left > 0 ? t("bagFreeLeft", { amount: money(left) }) : t("bagFreeOk");
    }
  }
  function refreshCart() {
    return fetch(root + "cart.js", { headers: { Accept: "application/json" } })
      .then(r => r.json())
      .then(c => { paintCount(c.item_count, false); renderBag(c); return c; })
      .catch(() => null);
  }
  function changeLine(key, qty) {
    return fetch(root + "cart/change.js", {
      method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(r => r.json()).then(c => { paintCount(c.item_count, true); renderBag(c); }).catch(() => toast(t("bagError")));
  }
  function addToCart(id) {
    return fetch(root + "cart/add.js", {
      method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(r => r.json().then(d => {
      if (!r.ok) { const err = new Error(d.description || d.message || t("bagError")); err.soft = true; throw err; }
      return d;
    }));
  }

  /* ---------- newsletter ---------- */
  (function newsletter() {
    const DONE = "br_news", OFF = "br_news_off";
    if (BR.newsOk) { store("localStorage", DONE, "sub"); setTimeout(() => toast(t("newsOk")), 400); return; }
    if (BR.newsErr) { setTimeout(() => openSheet("news"), 300); return; }
    if (!BR.newsPopup || store("localStorage", DONE) || store("sessionStorage", OFF)) return;
    const pop = $("#news");
    if (!pop) return;
    setTimeout(() => {
      if ($(".sheet.on") || $(".menu.on")) return;
      openSheet("news");
      store("sessionStorage", OFF, "1");
    }, (Number(BR.newsDelay) || 20) * 1000);
  })();

  /* ---------- le deck ---------- */
  const data = readJSON("deck-data");
  const track = $("#track"), deck = $("#deck"), tabsEl = $("#tabs");
  if (!data || !track || !deck) { refreshCart(); return; }

  /* pétales : les pétales 3D du teaser vidéo (rendus dans Blender), en planche d'images */
  const SPRITE = new Image();
  let spriteReady = false;
  SPRITE.onload = () => { spriteReady = true; };
  if (BR.petals) SPRITE.src = BR.petals;
  const PF = 24, PC = 80;
  const PAL = [["#8E4856", "#B9707D", "#E2B3BA"], ["#9C5462", "#C7848F", "#EEC9CE"], ["#7D3D4A", "#A85F6C", "#D59CA5"]];
  function drawPetal(ctx, p) {
    ctx.save();
    ctx.translate(p.x, p.y);
    ctx.rotate(p.rot);
    if (spriteReady) {
      const fr = ((Math.floor(p.fl / 6.2832 * PF) % PF) + PF) % PF, d = p.s * 2.3;
      ctx.drawImage(SPRITE, fr * PC, p.set * PC, PC, PC, -d / 2, -d / 2, d, d);
    } else {
      const f = Math.cos(p.fl), s = p.s, pal = PAL[p.set];
      ctx.scale(1, .28 + .72 * Math.abs(f));
      const g = ctx.createLinearGradient(0, s * .55, 0, -s * .6);
      g.addColorStop(0, pal[0]); g.addColorStop(.5, pal[1]); g.addColorStop(1, pal[2]);
      ctx.fillStyle = g;
      ctx.beginPath();
      ctx.moveTo(0, s * .55);
      ctx.bezierCurveTo(s * .62, s * .3, s * .66, -s * .42, s * .16, -s * .58);
      ctx.quadraticCurveTo(0, -s * .46, -s * .16, -s * .58);
      ctx.bezierCurveTo(-s * .66, -s * .42, -s * .62, s * .3, 0, s * .55);
      ctx.fill();
    }
    ctx.restore();
  }
  class Petals {
    constructor(slide, back, front, opt) {
      this.back = back; this.front = front; this.opt = opt;
      this.cb = back.getContext("2d"); this.cf = front.getContext("2d");
      this.list = []; this.run = false; this.raf = 0; this.t = 0; this.wind = 0; this.last = 0; this.mouse = null;
      slide.addEventListener("pointermove", e => {
        const r = this.back.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top;
        if (this.mouse) {
          const mx = x - this.mouse.x, my = y - this.mouse.y;
          for (const p of this.list) {
            const d = Math.hypot(p.x - x, p.y - y);
            if (d < 120) { const k = 1 - d / 120; p.vx += mx * 5 * k; p.vy2 += my * 3 * k; p.spinBoost += (Math.random() - .5) * 6 * k; }
          }
        }
        this.mouse = { x, y };
      });
      slide.addEventListener("pointerleave", () => { this.mouse = null; });
      this.resize();
    }
    resize() {
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      this.W = this.back.clientWidth; this.H = this.back.clientHeight; this.HF = this.front.clientHeight;
      [[this.back, this.H], [this.front, this.HF]].forEach(([c, h]) => {
        c.width = Math.max(1, Math.round(this.W * dpr)); c.height = Math.max(1, Math.round(h * dpr));
        c.getContext("2d").setTransform(dpr, 0, 0, dpr, 0, 0);
      });
      const want = Math.round(Math.max(10, Math.min(36, this.W / 22)) * this.opt.density);
      while (this.list.length < want) this.list.push(this.make(true));
      this.list.length = want;
      this.draw();
    }
    make(scatter) {
      const s = 9 + Math.random() * 13;
      return {
        x: Math.random() * this.W, y: scatter ? Math.random() * this.H : -30 - Math.random() * 60, s,
        vy: (18 + s * 2.1) * this.opt.speed, vx: 0, vy2: 0,
        sa: 14 + Math.random() * 26, sf: .5 + Math.random() * .9, ph: Math.random() * 6.28,
        rot: Math.random() * 6.28, spin: (Math.random() - .5) * 1.2, spinBoost: 0,
        fl: Math.random() * 6.28, fs: 2 + Math.random() * 2.6,
        front: Math.random() < .36, set: (Math.random() * 3) | 0
      };
    }
    start() {
      if (this.run) return;
      this.run = true; this.last = performance.now();
      if (reduce) { this.draw(); return; }
      const loop = now => {
        if (!this.run) return;
        const dt = Math.min(.05, (now - this.last) / 1000); this.last = now;
        if (!document.hidden) { this.step(dt); this.draw(); }
        this.raf = requestAnimationFrame(loop);
      };
      this.raf = requestAnimationFrame(loop);
    }
    stop() { this.run = false; cancelAnimationFrame(this.raf); }
    step(dt) {
      this.t += dt;
      this.wind += (Math.sin(this.t * .25) * 10 - this.wind) * Math.min(1, dt * .6);
      const damp = Math.pow(.2, dt);
      for (const p of this.list) {
        p.vx *= damp; p.vy2 *= damp; p.spinBoost *= damp;
        p.y += (p.vy + p.vy2) * dt;
        p.x += (Math.cos(this.t * p.sf + p.ph) * p.sa * p.sf + this.wind + p.vx) * dt;
        p.rot += (p.spin + p.spinBoost) * dt;
        p.fl += p.fs * dt;
        if (p.y > this.H + 30) Object.assign(p, this.make(false));
        if (p.x < -40) p.x = this.W + 30; else if (p.x > this.W + 40) p.x = -30;
      }
    }
    draw() {
      this.cb.clearRect(0, 0, this.W, this.H);
      this.cf.clearRect(0, 0, this.W, this.HF);
      for (const p of this.list) drawPetal(p.front && p.y < this.HF - 4 ? this.cf : this.cb, p);
    }
  }

  /* pièces → écrans ; les pièces avec la même étiquette « groupe-xxx » partagent un écran */
  const products = (data.products || []).slice();
  if (data.current && !products.some(p => p.handle === data.current.handle)) products.unshift(data.current);
  const tagOf = (p, prefix) => (p.tags || []).map(x => String(x).toLowerCase()).find(x => x.indexOf(prefix) === 0);
  const hasTag = (p, tag) => (p.tags || []).some(x => String(x).toLowerCase() === tag);
  const groups = [];
  products.forEach(p => {
    const g = tagOf(p, "groupe-");
    const key = g || "p-" + p.handle;
    let grp = groups.find(x => x.key === key);
    if (!grp) {
      const nm = g ? g.slice(7).replace(/-/g, " ") : p.title;
      grp = { key, name: g ? nm.charAt(0).toUpperCase() + nm.slice(1) : nm, items: [] };
      groups.push(grp);
    }
    grp.items.push(p);
  });
  groups.forEach(g => {
    g.petals = g.items.some(p => hasTag(p, "petales"));
    g.startBack = g.items.some(p => hasTag(p, "dos-d-abord"));
    g.items.forEach(p => {
      const re = new RegExp("\\b" + g.name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "\\b", "i");
      p.chip = g.items.length > 1 ? (p.title.replace(re, "").replace(/\s{2,}/g, " ").trim() || p.title) : "";
    });
  });

  const priceOf = (p, v) => (v ? v.price : p.price);
  const compareOf = (p, v) => (v ? v.compare : p.compare) || 0;
  const priceHTML = (p, v) => {
    const pr = priceOf(p, v), cp = compareOf(p, v);
    return "<strong><small>CHF</small>" + amount(pr) + "</strong>" + (cp > pr ? "<s>" + money(cp) + "</s>" : "");
  };
  const shipText = (p, v) => priceOf(p, v) >= (Number(BR.free) || 4000) ? t("shipFree") : t("shipFrom", { amount: money(BR.free || 4000) });
  const isSingle = p => p.variants.length === 1 && /default title/i.test(p.variants[0].title);
  const sizeLabel = (p, v) => (p.options && p.options.length === 1 ? v.o1 : v.title);
  const pieceClass = p => (p.ratio ? (p.ratio < 1 ? "piece--tall" : "piece--wide") : "piece--photo");

  function word() {
    return '<p class="word" aria-hidden="true"><span class="word__in">' + "BR4NDOM".split("").map((ch, i) =>
      '<i style="--i:' + i + '"' + (ch === "4" ? ' class="four"' : "") + ">" + ch + "</i>").join("") + "</span></p>";
  }
  function sizesHTML(p) {
    if (isSingle(p)) return "";
    return p.variants.map((v, i) => `<button type="button" class="size${v.available ? "" : " epuise"}" role="radio" aria-checked="false" data-v="${i}"${v.available ? "" : ' aria-disabled="true"'}>${esc(sizeLabel(p, v))}</button>`).join("");
  }
  function productSlide(g) {
    const p = g.items[0];
    const types = g.items.length > 1 ? '<div class="types" role="radiogroup" aria-label="' + esc(t("piece")) + '">' + g.items.map((x, i) =>
      `<button type="button" class="type${i ? "" : " on"}" role="radio" aria-checked="${i ? "false" : "true"}" data-p="${i}">${esc(x.chip)}</button>`).join("") + "</div>" : "";
    return `<section class="slide${g.petals ? " has-petals" : ""}" aria-label="${esc(g.name)}">
      ${g.petals ? '<canvas class="petals petals--back" aria-hidden="true"></canvas>' : ""}
      <div class="stage">
        ${word()}
        <div class="piece ${pieceClass(p)}" data-top="${g.startBack ? p.tb : p.tf}"${p.ratio ? ' style="aspect-ratio:' + p.ratio + '"' : ""}>
          <div class="floor"></div>
          <div class="float">
            <div class="tee" tabindex="0" role="button" aria-label="${esc(t("turn"))}">
              <div class="tee__in">
                <img class="f" src="${esc(p.face)}" alt="${esc(p.title)}, ${esc(t("front"))}" draggable="false">
                <img class="b" src="${esc(p.dos)}" alt="${esc(p.title)}, ${esc(t("back"))}" draggable="false">
              </div>
            </div>
          </div>
        </div>
        ${g.petals ? '<canvas class="petals petals--front" aria-hidden="true"></canvas>' : ""}
        <div class="side" role="group" aria-label="${esc(t("view"))}"><button type="button">${esc(t("front"))}</button><button type="button">${esc(t("back"))}</button></div>
      </div>
      <div class="card">
        <div class="card__top"><h2 class="name">${esc(g.name)}</h2>${types}</div>
        <div class="price">${priceHTML(p, null)}</div>
        <p class="ship">${esc(shipText(p, null))}</p>
        <div class="sizes" role="radiogroup" aria-label="${esc(t("size"))}">${sizesHTML(p)}</div>
        <div class="cta">
          <button type="button" class="add" aria-disabled="true"><span class="add__t"></span><span class="add__p"></span></button>
          <button type="button" class="plus" aria-label="${esc(t("details"))}">+</button>
        </div>
      </div>
    </section>`;
  }
  function soonSlide(teaser) {
    return `<section class="slide slide--soon has-petals" aria-label="${esc(t("teaserEyebrow"))}">
      <canvas class="petals petals--back" aria-hidden="true"></canvas>
      <div class="stage">
        ${word()}
        <div class="piece" data-top="0.36">
          <div class="floor floor--soft"></div>
          <div class="float"><div class="veil" aria-hidden="true"><img src="${esc(teaser.image)}" alt=""></div></div>
        </div>
        <canvas class="petals petals--front" aria-hidden="true"></canvas>
      </div>
      <div class="card card--soon">
        <p class="eyebrow">${esc(t("teaserEyebrow"))}</p>
        <h2 class="soon">${esc(t("teaserTitle"))}</h2>
        <p class="soon__p">${esc(t("teaserText"))}</p>
        <div class="cta"><a class="add" href="${esc(teaser.instagram || "https://www.instagram.com/br4ndom.ch/")}" target="_blank" rel="noopener"><span>${esc(t("teaserFollow"))}</span><span aria-hidden="true">↗</span></a></div>
      </div>
    </section>`;
  }

  const slides = [];
  let index = 0, suppressClick = false;
  function setupSlide(el, g) {
    const s = { el, g, angle: g.startBack ? 180 : 0, p: g.items[0], v: null, petals: null };
    const tee = $(".tee", el), inner = $(".tee__in", el), sideBtns = $$(".side button", el);
    const tilt = { x: 0, y: 0 };
    let startX = 0, a0 = 0, moved = false, active = false;
    const apply = () => {
      inner.style.transform = `rotateX(${tilt.x}deg) rotateY(${s.angle + tilt.y}deg)`;
      const back = isBack(s.angle);
      sideBtns.forEach((b, i) => b.classList.toggle("on", i === (back ? 1 : 0)));
    };
    const refresh = () => {
      const add = $(".add", el), p = s.p, v = s.v;
      let label, ready = false;
      if (!p.available) label = t("soldOut");
      else if (!v) label = t("chooseSize");
      else if (!v.available) label = t("soldOut");
      else { label = t("add"); ready = true; }
      add.setAttribute("aria-disabled", ready ? "false" : "true");
      $(".add__t", add).textContent = label;
      $(".add__p", add).textContent = ready ? money(v.price) : "";
      $(".price", el).innerHTML = priceHTML(p, v);
      $(".ship", el).textContent = shipText(p, v);
    };
    const bindSizes = () => {
      $$(".size", el).forEach(b => b.addEventListener("click", () => {
        const v = s.p.variants[Number(b.getAttribute("data-v"))];
        if (!v || !v.available) return;
        $$(".size", el).forEach(x => { x.classList.toggle("on", x === b); x.setAttribute("aria-checked", x === b ? "true" : "false"); });
        s.v = v;
        refresh();
      }));
    };
    const pickProduct = p => {
      s.p = p;
      s.v = isSingle(p) ? p.variants[0] : null;
      $(".sizes", el).innerHTML = sizesHTML(p);
      bindSizes();
      refresh();
    };
    tee.addEventListener("pointerdown", e => {
      e.stopPropagation();
      active = true; moved = false; startX = e.clientX; a0 = s.angle;
      tee.setPointerCapture(e.pointerId);
      inner.classList.add("drag"); tee.classList.add("grab");
    });
    tee.addEventListener("pointermove", e => {
      if (!active) {
        if (e.pointerType === "mouse") {
          const r = tee.getBoundingClientRect();
          tilt.y = ((e.clientX - r.left) / r.width - .5) * 14;
          tilt.x = -((e.clientY - r.top) / r.height - .5) * 8;
          apply();
        }
        return;
      }
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 5) moved = true;
      s.angle = a0 + dx * .6;
      apply();
    });
    const end = () => {
      if (!active) return;
      active = false;
      inner.classList.remove("drag"); tee.classList.remove("grab");
      s.angle = moved ? Math.round(s.angle / 180) * 180 : a0 + 180;
      apply();
    };
    tee.addEventListener("pointerup", end);
    tee.addEventListener("pointercancel", end);
    tee.addEventListener("pointerleave", () => { if (!active) { tilt.x = 0; tilt.y = 0; apply(); } });
    tee.addEventListener("keydown", e => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); s.angle += 180; apply(); } });
    sideBtns.forEach((b, i) => b.addEventListener("click", () => { if ((i === 1) !== isBack(s.angle)) { s.angle += 180; apply(); } }));
    $$(".type", el).forEach(b => b.addEventListener("click", () => {
      const p = g.items[Number(b.getAttribute("data-p"))];
      if (!p || p === s.p) return;
      $$(".type", el).forEach(x => { x.classList.toggle("on", x === b); x.setAttribute("aria-checked", x === b ? "true" : "false"); });
      if (!reduce) $(".float", el).animate([{ opacity: 1 }, { opacity: 0 }, { opacity: 1 }], { duration: 520, easing: "ease-in-out" });
      setTimeout(() => { $("img.f", el).src = p.face; $("img.b", el).src = p.dos; }, reduce ? 0 : 260);
      pickProduct(p);
      if (document.body.classList.contains("t-product") && p.url) history.replaceState(null, "", p.url);
    }));
    $(".add", el).addEventListener("click", () => {
      const add = $(".add", el);
      if (!s.p.available || (s.v && !s.v.available)) return;
      if (!s.v) {
        const row = $(".sizes", el);
        row.classList.remove("shake"); void row.offsetWidth; row.classList.add("shake");
        toast(t("pickFirst"));
        return;
      }
      add.classList.add("busy");
      addToCart(s.v.id).then(() => {
        fly($(isBack(s.angle) ? "img.b" : "img.f", el));
        const name = s.p.title + (isSingle(s.p) ? "" : ", " + sizeLabel(s.p, s.v));
        toast(t("bagAdded", { name }));
        return refreshCart().then(c => { if (c) setTimeout(() => paintCount(c.item_count, true), reduce ? 0 : 760); });
      }).catch(err => toast(err && err.message ? err.message : t("bagError")))
        .finally(() => add.classList.remove("busy"));
    });
    $(".plus", el).addEventListener("click", () => openDetails(s.p));
    pickProduct(s.p);
    apply();
    const back = $(".petals--back", el), front = $(".petals--front", el);
    if (back && front) s.petals = new Petals(el, back, front, { density: 1, speed: 1 });
    return s;
  }
  function setupSoon(el) {
    const s = { el, soon: true, petals: null };
    const back = $(".petals--back", el), front = $(".petals--front", el);
    if (back && front) s.petals = new Petals(el, back, front, { density: .45, speed: .55 });
    return s;
  }

  function openDetails(p) {
    const body = $("#details-body");
    $("#details-title").textContent = p.title;
    let html = p.desc ? '<div class="desc">' + p.desc + "</div>" : "";
    if (p.guide) {
      const rows = p.guide.split("|").map(r => r.split(","));
      html += "<h4>" + esc(t("guide")) + '</h4><div class="guide-wrap"><table class="guide"><thead><tr><th>' + esc(t("size")) + "</th><th>" + esc(t("gLength")) + "</th><th>" +
        esc(t("gChest")) + "</th><th>" + esc(t("gShoulders")) + "</th><th>" + esc(t("gSleeve")) + "</th></tr></thead><tbody>" +
        rows.map(r => "<tr>" + r.map((c, i) => (i ? "<td>" : "<th scope=\"row\">") + esc(c) + (i ? "</td>" : "</th>")).join("") + "</tr>").join("") +
        '</tbody></table></div><p class="note">' + esc(t("guideNote")) + "</p>";
    }
    html += '<p class="note">' + esc(shipText(p, null)) + ". " + esc(t("delivery")) + "</p>";
    html += '<button type="button" class="promo" data-news>' + esc(t("promo")) + "</button>";
    body.innerHTML = html;
    const pr = $("[data-news]", body);
    if (pr) pr.addEventListener("click", () => openSheet("news"));
    openSheet("details");
  }

  function fly(img) {
    if (reduce || !img) return;
    const bag = $(".hd__bag");
    if (!bag) return;
    const r = img.getBoundingClientRect(), tg = bag.getBoundingClientRect();
    const c = document.createElement("img");
    c.src = img.src; c.className = "flyer"; c.alt = "";
    Object.assign(c.style, { left: r.left + "px", top: r.top + "px", width: r.width + "px", height: r.height + "px" });
    document.body.appendChild(c);
    const dx = tg.left + tg.width / 2 - (r.left + r.width / 2), dy = tg.top + tg.height / 2 - (r.top + r.height / 2);
    requestAnimationFrame(() => requestAnimationFrame(() => { c.style.transform = `translate(${dx}px, ${dy}px) scale(.05)`; c.style.opacity = ".3"; }));
    setTimeout(() => c.remove(), 950);
  }

  /* BR4NDOM prend toute la largeur, et le haut de la pièce passe devant le bas des lettres */
  function fitWords() {
    const desk = innerWidth >= 980;
    $$(".word", track).forEach(w => {
      const st = w.parentElement, inner = $(".word__in", w), piece = $(".piece", st);
      const W = st.clientWidth, H = st.clientHeight;
      if (!W || !H || !piece) return;
      inner.style.fontSize = "100px";
      const ww = inner.getBoundingClientRect().width || 1;
      const fs = Math.min(W * (desk ? .92 : .96) / ww * 100, H * (desk ? .5 : .36));
      inner.style.fontSize = fs.toFixed(1) + "px";
      const gt = parseFloat(piece.getAttribute("data-top") || "0.03");
      const top = piece.offsetTop + piece.offsetHeight * (gt + .03) - inner.offsetHeight * .8;
      w.style.top = Math.max(H * .02, top).toFixed(1) + "px";
    });
  }

  function go(i, instant) {
    index = Math.max(0, Math.min(slides.length - 1, i));
    if (instant) track.classList.add("drag");
    track.style.transform = `translateX(${-index * 100}%)`;
    if (instant) { void track.offsetWidth; track.classList.remove("drag"); }
    $$(".tab", tabsEl).forEach((tb, k) => { tb.classList.toggle("on", k === index); tb.setAttribute("aria-current", k === index ? "true" : "false"); });
    slides.forEach((s, k) => {
      if (s.petals) { if (k === index) s.petals.start(); else s.petals.stop(); }
      s.el.toggleAttribute("inert", k !== index);
    });
    const s = slides[index];
    if (!instant && s && s.p && document.body.classList.contains("t-product") && s.p.url) history.replaceState(null, "", s.p.url);
  }

  /* construction */
  const html = groups.map(productSlide);
  if (data.teaser) html.push(soonSlide(data.teaser));
  track.innerHTML = html.join("");
  const slideEls = $$(".slide", track);
  groups.forEach((g, i) => slides.push(setupSlide(slideEls[i], g)));
  if (data.teaser) slides.push(setupSoon(slideEls[slideEls.length - 1]));
  if (tabsEl) {
    tabsEl.innerHTML = slides.map((s, i) => `<button type="button" class="tab" data-i="${i}">${s.soon ? esc(t("teaserTab")) + "<i></i>" : esc(s.g.name)}</button>`).join("");
    tabsEl.addEventListener("click", e => { const b = e.target.closest(".tab"); if (b) go(Number(b.getAttribute("data-i"))); });
  }
  /* brandom.ch/#bientot ouvre directement l'écran du teasing (lien pour la bio Instagram) */
  if (/^#(bientot|soon|bald)$/i.test(location.hash)) {
    const k = slides.findIndex(s => s.soon);
    if (k > -1) index = k;
  } else if (data.start) {
    const k = slides.findIndex(s => s.g && s.g.items.some(p => p.handle === data.start));
    if (k > -1) {
      index = k;
      const s = slides[k], p = s.g.items.find(x => x.handle === data.start);
      const chip = $$(".type", s.el)[s.g.items.indexOf(p)];
      if (chip && p !== s.p) chip.click();
    }
  }
  fitWords();
  go(index, true);

  /* le menu ouvre directement le bon écran */
  $$("#menu [data-handle]").forEach(a => a.addEventListener("click", e => {
    const h = a.getAttribute("data-handle");
    const k = slides.findIndex(s => s.g && s.g.items.some(p => p.handle === h));
    if (k > -1) { e.preventDefault(); closeAll(); go(k); }
  }));
  $$("#menu [data-soon]").forEach(a => a.addEventListener("click", e => {
    const k = slides.findIndex(s => s.soon);
    if (k > -1) { e.preventDefault(); closeAll(); go(k); }
  }));

  /* glisser d'un écran à l'autre */
  let sw = null;
  deck.addEventListener("pointerdown", e => {
    if (e.target.closest(".tee")) return;
    sw = { x: e.clientX, y: e.clientY, t: performance.now(), dx: 0, horiz: null, id: e.pointerId };
  });
  deck.addEventListener("pointermove", e => {
    if (!sw || e.pointerId !== sw.id) return;
    const dx = e.clientX - sw.x, dy = e.clientY - sw.y;
    if (sw.horiz === null) {
      if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
      sw.horiz = Math.abs(dx) > Math.abs(dy);
      if (sw.horiz) { deck.setPointerCapture(e.pointerId); track.classList.add("drag"); }
    }
    if (!sw.horiz) return;
    const edge = (index === 0 && dx > 0) || (index === slides.length - 1 && dx < 0);
    sw.dx = edge ? dx * .3 : dx;
    track.style.transform = `translateX(calc(${-index * 100}% + ${sw.dx}px))`;
  });
  const endSwipe = () => {
    if (!sw) return;
    const s = sw; sw = null;
    if (!s.horiz) return;
    track.classList.remove("drag");
    suppressClick = true; setTimeout(() => { suppressClick = false; }, 60);
    const v = s.dx / Math.max(1, performance.now() - s.t), w = deck.clientWidth;
    if (s.dx < -w * .18 || v < -.45) go(index + 1);
    else if (s.dx > w * .18 || v > .45) go(index - 1);
    else go(index);
  };
  deck.addEventListener("pointerup", endSwipe);
  deck.addEventListener("pointercancel", endSwipe);
  deck.addEventListener("click", e => { if (suppressClick) { e.stopPropagation(); e.preventDefault(); } }, true);
  document.addEventListener("keydown", e => {
    if ($(".sheet.on") || $(".menu.on")) return;
    if (e.target && /input|textarea|select/i.test(e.target.tagName)) return;
    if (e.key === "ArrowRight") go(index + 1);
    else if (e.key === "ArrowLeft") go(index - 1);
  });
  let rz = 0;
  window.addEventListener("resize", () => {
    clearTimeout(rz);
    rz = setTimeout(() => { fitWords(); slides.forEach(s => s.petals && s.petals.resize()); go(index, true); }, 80);
  });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitWords);
  window.addEventListener("load", fitWords);
  if (!reduce) requestAnimationFrame(() => { const app = $("#app"); if (app) app.classList.add("intro"); });
  refreshCart();
})();
